import { Box, Typography } from '@material-ui/core';
import { ReportProblemOutlined } from '@material-ui/icons';

export const GenericErrorPage = () => {
  return (
    <Box
      className='w-full h-full'
      display='flex'
      justifyContent='center'
      textAlign='center'
      flexDirection='column'
      alignItems='center'
    >
      <Box clone mb={1}>
        <ReportProblemOutlined color='error' className='extra-large' />
      </Box>

      <Typography variant='h4'>
        <span>Something went wrong.</span>
      </Typography>
      <Typography variant='h4'>
        <span>Please try again later</span>
      </Typography>
    </Box>
  );
};
